// Section 5 and 16: Devout. Trust loss from unequal rations is -2 instead of -8; happiness is
// less tied to food (the food part of the needs term is halved). Constants: config.traits.devout.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { needsOf } from '../../core/queries';
import { neverRestricts, targetPerson } from '../../core/content-helpers';
import { defineTrait } from '../../core/registry';

export function devout(config: Config) {
  const c = config.traits.devout;

  return defineTrait({
    id: 'devout',
    label: 'Devout',
    section: 'S5',
    modifierTargets: ['trustChange', 'happinessTarget'],
    modifierKeys: { trustChange: ['rationed-short', 'rationed-short-deviation'] },
    modifiers(ctx, target) {
      const p = targetPerson(ctx, target);
      if (p?.traits.includes('devout') !== true) return [];
      if (
        target.kind === 'trustChange' &&
        (target.cause === 'rationed-short' || target.cause === 'rationed-short-deviation')
      ) {
        return [mod.mul('trait:devout', c.unequalRationTrustMul, 'devout')];
      }
      if (target.kind === 'happinessTarget') {
        // The needs term averages four needs over +/-needsSpan; give back (1 - weight) of food's share.
        const food = needsOf(ctx.state, p.id).food;
        const refund =
          ((1 - c.foodHappinessWeight) * ctx.cfg.happiness.needsSpan * 2 * (1 - food)) / 4;
        return refund > 0 ? [mod.add('trait:devout', refund, 'less tied to food')] : [];
      }
      return [];
    },
    restricts: neverRestricts,
  });
}
